export default "__VITE_ASSET__d7160542__"